var exports = {
  "w": "sidebarTooltip__5FH3V6",
  "F": "sidebar-tooltip-appear__tv1Huj",
};

module.exports = exports;
